import React, { Component } from 'react'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import CSSTransition from 'react-transition-group/CSSTransition'
import s from './Stepper.scss'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'

// I don't know how this works. But it does...

export default class Stepper extends Component {
  render() {
    const { children, step } = this.props
    const isReverse = !(step === 2)

    return (
      <TransitionGroup className={s.containerOuter}>
        <CSSTransition
          key={step - 1}
          timeout={600}
          classNames={{
            enter: isReverse ? s.enterReverse : s.enter,
            enterActive: isReverse ? s.enterActiveReverse : s.enterActive,
            appear: isReverse ? s.enterReverse : s.enter,
            appearActive: isReverse ? s.enterActiveReverse : s.enterActive,
            exit: !isReverse ? s.exitReverse : s.exit,
            exitActive: !isReverse ? s.exitActiveReverse : s.exitActive,
          }}
        >
          {children[step - 1]}
        </CSSTransition>
      </TransitionGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Stepper/Stepper.jsx